// extracted by mini-css-extract-plugin
export default {"title":"authPage_title__q10q8","errorText":"authPage_errorText__xhdsX","form":"authPage_form__Hp4FU"};